import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import CommentCard from './CommentCard';
import dataModel from '../../../../../models/DataModel';
import './TaskCompletionStepComments.scss';
import Textarea from '../../../../Textarea';

export class TaskCompletionStepComments extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { 
      commentText: '',
      comments: [], 
    };
  }

  componentDidMount() {
    this.updateComments();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.completionStep != this.props.completionStep) {
      // object changed in memory/store
      this.updateComments();
    }
  }

  updateComments() {
    const { completionStep } = this.props;
    if (completionStep.comments) {
      completionStep.comments.sort((c1, c2) => {
        return c1.created_at < c2.created_at
          ? 1
          : c1.created_at > c2.created_at ? -1 : 0;
      });
      this.setState({ comments: completionStep.comments });
    }
  }

  sortComments(){
    const { comments } = this.state;
    comments.sort((c1, c2) => {
      return c1.created_at < c2.created_at
        ? 1
        : c1.created_at > c2.created_at ? -1 : 0;
    });
    this.setState({ comments });
  }

  handleSendComment() {
    const { completionStep } = this.props;
    if (this.state.commentText) {
      if (completionStep) {
        if (this.props.type == 'REJECTED') {
          this.setState({ commentText: '' });
          if (this.props.commentSent) {
            this.props.commentSent(this.state.commentText);
          }
        }
        else {
          dataModel.commentsDAO.createComment({
            body: this.state.commentText,
            caption: this.props.type,
            commentable_type: 'CompletionCriterion',
            commentable_id: completionStep.id,
            user_id: this.props.currentUser.id,
          }, false, null, { recordDescriptor: { comments: {} } })
          .then(response=>{
            const updatedComments = this.state.comments;
            updatedComments.push(response);
            this.setState({ comments: updatedComments });
            this.sortComments();
          });
          this.setState({ commentText: '' });
          if (this.props.commentSent) {
            this.props.commentSent(this.state.commentText);
          }
        }
      }
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 13) {
      e.preventDefault();
      this.handleSendComment();
      document.activeElement.blur();
    } else if (e.keyCode == 27) {
      this.handleCommentCancel();
    }
  }

  handleCommentChange(e) {
    this.setState({ commentText: e.target.value });
  }

  handleSetElement(element) {
    if (!this.element && element) {
      this.element = element;
      this.element.focus();  
    }
  }

  render() {
    const { completionStep } = this.props;
    if (!completionStep) {
      return null;
    }
    let sendButton = (
      <div className="send-button disabled">
        <div className="send-text disabled">SEND</div>
      </div>
    );
    if (this.state.commentText) {
      sendButton = (
        <div className="send-button" onClick={this.handleSendComment}>
          <div className="send-text">SEND</div>
        </div>
      );
    }

    const displayComments = this.state.comments.map(comment => <CommentCard comment={comment} key={'comment_2_' + (comment.id ? comment.id : Math.random())} />);
    return (
      <div
        className={
          'task-completion-step-comments ' +
          (this.props.fromPopup ? 'from-popup' : '')
        }
        id={this.props.id}
        onClick={this.handleCommentCancel}
        onTouchStart={this.handleCommentCancel}
      >
        <div className="comment-list">
          <div
            className={
              'comment-title ' +
              (this.props.fromPopup ? 'from-popup ' : '') +
              (displayComments.length == 0 ? 'empty' : '')
            }
          >
            Comments
          </div>
          {displayComments.length > 0 && (
            <div className="comments">{displayComments}</div>
          )}
        </div>
        <div className="task-comment-input">
          <Textarea
            className="text-input"
            rows={3}
            ref={element => this.handleSetElement(element)}
            placeholder={
              this.props.placeholder
                ? this.props.placeholder
                : 'Leave comment here.'
            }
            onChange={this.handleCommentChange}
            value={this.state.commentText}
            onKeyDown={this.handleKeyDown}
            dataId={completionStep.id}
            type="send"
            style={{ resize: 'none' }}
          />
          {sendButton}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users ? state.new_users.currentUser : null,
  };
};
export default connect(mapStateToProps)(
  TaskCompletionStepComments
);



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskCompletionStepsContainer/TaskCompletionSteps/TaskCompletionStepComments/index.js